import { render, staticRenderFns } from "./NsiForm.vue?vue&type=template&id=160391ac&scoped=true&"
import script from "./NsiForm.vue?vue&type=script&lang=js&"
export * from "./NsiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160391ac",
  null
  
)

export default component.exports